export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// ./~/@ngx-translate/http-loader/index.js
// module id = 370
// module chunks = 4